import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { CustomerAttributeModalComponent } from './customer-attributes-modal.component';
import { CustomerAttributesComponent } from './customer-attributes.component';

@NgModule({
    declarations: [
        CustomerAttributesComponent,
        CustomerAttributeModalComponent
    ],
    providers: [],
    imports: [
        CommonModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerAttributesComponent,
        CustomerAttributeModalComponent
    ]
})

export class CustomerAttributesModule {}
